export enum CaptionStatusType {
  Off = 'Off',
  On = 'On',
}
